import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";

class CounselingHistoriesList extends Component {
  render() {
    const { action } = this.props;
    const counselingHistories = this.props.counselingHistories.filter((o) => !o._destroy);

    return (
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {counselingHistories.map((o) => {
            return (
              <tr key={o.id}>
                <td>{o.title}</td>
                <td>{o.description}</td>
                <td>
                  {action === "edit" && (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.editCounselingHistory(o);
                      }}
                    >
                      Edit
                    </a>
                  )}
                </td>
              </tr>
            );
          })}
          {action == "edit" && (
            <tr>
              <td colSpan={7} className="text-center">
                <Button
                  variant="link"
                  onClick={() => {
                    this.props.newCounselingHistory();
                  }}
                >
                  Add Counseling History
                </Button>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    );
  }
}

const mapStateToProps = (state, _) => {
  return {
    isStaffApp: state.config.isStaffApp,
    counselingHistories: state.counseling_histories,
    action: state.ui.action,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    newCounselingHistory: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "counselingHistory" },
      });
    },
    editCounselingHistory: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: { resourceName: "counselingHistory", resource },
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CounselingHistoriesList);
